import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense.ts";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@babackapp/ui/components/dialog";
import { PropsWithChildren, useState } from "react";
import { ShopWebhookDto } from "@babackapp/private-api-client/types";
import useDeleteWebhook from "@babackapp/private-api-client/client/use-delete-webhook";
import useUpdateWebhook from "@babackapp/private-api-client/client/use-update-webhook";
import useTranslation from "@babackapp/translations/use-translation";
import WebhookEventTester from "./webhook-events-tester.tsx";
import WebhookForm from "./webhook-form.tsx";

type UpdateWebhookDialogProps = {
  webhook: ShopWebhookDto;
};

export default function UpdateWebhookDialog({
  children,
  webhook,
}: PropsWithChildren<UpdateWebhookDialogProps>) {
  const t = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);

  const { data: shop } = useCurrentShopSuspense();

  const { mutateAsync: updateWebhook } = useUpdateWebhook(shop);
  const { mutateAsync: deleteWebhook } = useDeleteWebhook(shop);

  return (
    <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="pt-10">
        <DialogHeader className="flex flex-col justify-start items-start">
          <DialogTitle>
            {t("settings.integrations.webhooks.menu.edit")}
          </DialogTitle>
          <DialogDescription>{webhook.url}</DialogDescription>
          <div className="mt-2">
            <WebhookEventTester webhook={webhook} />
          </div>
        </DialogHeader>
        <WebhookForm
          onSubmit={(data) => updateWebhook({ ...data, id: webhook.id })}
          onRemove={() => deleteWebhook(webhook.id || "")}
          defaultValues={{
            url: webhook.url,
            secret: webhook.secret ?? "",
            subscriptions: webhook.subscriptions,
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
